import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../Util/CommonUtils";

export default function UserFilter(props) {
  const [open, setOpen] = React.useState(props.open);
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const status = [
    { label: t("STATUS_ACTIVE") },
    { label: t("STATUS_IN_ACTIVE") },
  ];

  const [payload, setPayload] = useState({
    status: "",
  });

  const handleClose = () => {
    setPayload({
      status: "",
    });
    setOpen(false);
  };

  const [error, setError] = useState({
    status: false,
  });

  const handleChangeStatus = (data) => {
    let status = "";
    switch (data) {
      case t("STATUS_ACTIVE"):
        status = "ACTIVE";
        break;
      case t("STATUS_IN_ACTIVE"):
        status = "INACTIVE";
        break;
      default:
        status = "";
    }
    return status;
  };
  const handleSubmit = () => {
    if (payload.status.trim() === "") {
      Toast(t("COMMON154"), "error");
      return;
    }
    props.applyFilter(payload);
    setPayload({
      status: "",
    });
    handleClose();
  };

  useEffect(() => { }, []);

  return (
    <>
      <Tooltip title={t("COMMON006")}>
        <Box
          item
          className={"filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setOpen(true)}
        >
          {isHovered ? (
            <FilterIconHover style={{ color: "#474a4e" }} />
          ) : (
            <FilterIcon style={{ color: "#474a4e" }} />
          )}
        </Box>
      </Tooltip>
      <Dialog
        open={open}
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: "20px !important",
            minWidth: "40vw",
            backgroundColor: "#fff",
            color: "#434547",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={handleClose} />
          </IconButton>
          <Typography
            style={{
              color: "black",
              fontSize: "20px",
              fontWeight: "450",
            }}
          >
            {t("FILTER")}
          </Typography>
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent style={{ paddingBottom: "0px" }}>
          <Grid
            container
            justifyContent="center"
            rowSpacing={2}
            columnSpacing={1}
          >
            <Grid item xs={12} sm={12}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                disablePortal
                id="combo-box-demo"
                options={status}
                sx={{
                  width: "100%",
                }}
                value={payload.status}
                error={error.status}
                renderInput={(params) => (
                  <TextField {...params} label={t("CUSTDATABLE07")} />
                )}
                onChange={(event, value) => {
                  if (!CommonUtil.isEmpty(value)) {
                    const selectedStatus = handleChangeStatus(value.label);
                    setPayload({
                      ...payload,
                      status: selectedStatus,
                    });
                  } else {
                    setPayload({
                      ...payload,
                      status: "",
                    });
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
          }}
        >
          <CancelButtons
            variant="contained"
            color="secondary"
            onClick={handleClose}
          >
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON008")}
            </Typography>
          </CancelButtons>
          <SubmitButtons variant="contained" onClick={handleSubmit}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON007")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
